import styled from 'styled-components';
import { getTextPresetCss, Size } from '@optimus-web/common';
import { Component, Decision, getComponentToken, SPACING, TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { PlaceholderElement } from '../Input';

const getTextareaToken = getComponentToken(Component.Textarea);

export const TextareaContainerElement = styled.div`
    display: flex;
    width: 100%;
`;

interface TextareaElementProps {
    inputSize?: Size;
}

export const TextareaStyledComponent = styled.textarea<TextareaElementProps>`
    background: transparent;
    border: 0;
    ${(props) => getTextPresetCss(props.inputSize === 'small' ? TEXT_PRESET_KEY['200r'] : TEXT_PRESET_KEY['300r'])}
    color: ${(props) => getTextareaToken(Decision.Color, { state: props.disabled ? 'disabled' : undefined })};
    outline: none;
    padding: ${SPACING[100]}px ${(props) => (props.inputSize === 'small' ? SPACING[100] : SPACING[200])}px;
    resize: vertical;
    width: 100%;
`;

export const TextAreaPlaceholder = styled(PlaceholderElement)`
    width: calc(100% - ${(props) => (props.inputSize === 'small' ? SPACING[100] : SPACING[200])}px);
    height: 100%;
    top: ${SPACING[0]}px;
    left: ${(props) => (props.inputSize === 'small' ? SPACING[100] : SPACING[200])}px;
    padding: ${SPACING[100]}px ${SPACING[0]}px;
    white-space: break-spaces;
    text-overflow: inherit;
    transform: translateY(${SPACING[0]});
    word-break: break-word;
`;

export const ValueContainerElement = styled.div`
    position: relative;
    width: 100%;
    display: flex;
`;
